import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { FieldGridProps, FieldItemProps } from './FieldGrid.props';

export const FieldGrid: React.FC<FieldGridProps> = ({
  columns = 2,
  children,
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns:
          columns === 3 ? '1fr 1fr 1fr' : '1fr 1fr',
        gap: '8px 20px',
      }}
    >
      {children}
    </Box>
  );
};

export const FieldItem: React.FC<FieldItemProps> = ({
  label,
  value,
  editable = false,
  fullWidth = false,
}) => {
  const content = (
    <Box
      sx={{
        ...(editable && {
          cursor: 'pointer',
          borderRadius: 1,
          px: 0.5,
          mx: -0.5,
          '&:hover': {
            border: 1,
            borderColor: 'v4.borderDark',
          },
        }),
      }}
    >
      <Typography
        sx={{
          fontSize: '9px',
          fontWeight: 600,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
        }}
      >
        {label}
      </Typography>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Typography variant="body2" sx={{ fontSize: '13px' }}>
          {value}
        </Typography>
      ) : (
        <Box sx={{ fontSize: '13px' }}>
          {value}
        </Box>
      )}
    </Box>
  );

  if (fullWidth) {
    return <Box sx={{ gridColumn: '1 / -1' }}>{content}</Box>;
  }

  return content;
};
